export default "__VITE_ASSET__ecc203fb__"